import TweenMax from 'gsap/TweenMax';

export default function Smile(container, canvas, duration, beforeAnimation) {
  const {
    top: containerTop,
    left: containerLeft,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const {
    top: canvasTop,
    left: canvasLeft,
    width: canvasWidth,
  } = canvas.getBoundingClientRect();

  const initialX =
    canvasLeft - containerLeft + (canvasWidth - containerWidth) / 2;
  const initialY = containerTop - canvasTop;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.5, { opacity: 1 });
}
